import { IConsentDialogContent } from '../form-consent-checkbox.component';
import { BaseConsentVariant } from './base-consent-variant';

export class MarketingConsentVariant extends BaseConsentVariant {
    identifier = 'general_marketing_information_checkbox';

    protected get labelHtmlKey(): string {
        return 'form.consent.marketing.label';
    }

    protected get dialogContent(): IConsentDialogContent {
        return {
            bodyHtmlKey: 'form.consent.marketing.dialog.body',
            buttonTextKey: 'form.consent.marketing.dialog.button',
        };
    }
}
